import React from 'react'
/* eslint-disable react/forbid-prop-types */
import { any } from 'prop-types'
import PermissionRouteWithFallback from './PermissionRouteWithFallback'

/**
 * Gates the discovery-ai configuration pages on the permission that service actually enforces.
 *
 * SecurityConfiguration in discovery-ai puts /admin/** behind DiscoveryDatabasePermission —
 * approved applications, review prompts and content kinds are configuration administration, a
 * different and broader job than working the content review queue. Reviewers hold
 * DiscoveryContentReviewPermission and deliberately do not get this.
 */
export default function DatabasePermissionRouteWithFallback({
  component: Component,
  path,
  exact,
  fallback: Fallback,
  children,
  requirePersonalData,
}) {
  return (
    <PermissionRouteWithFallback
      component={Component}
      path={path}
      exact={exact}
      fallback={Fallback}
      requirePersonalData={requirePersonalData}
      permissionName="DiscoveryDatabasePermission"
      permissionContext="DiscoveryAdminDatabaseContext"
    >
      {children}
    </PermissionRouteWithFallback>
  )
}

DatabasePermissionRouteWithFallback.propTypes = {
  children: any,
  component: any,
  fallback: any.isRequired,
  path: any,
  exact: any,
  requirePersonalData: any,
}
